import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { issueStore } from '@/stores/issue'
import Filelist from '@/components/Filelist.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowTagsCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Locatie van probleem",
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { class: "no-mb" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(Filelist, {
                media: _unref(issueStore)().issue.taggedImages
              }, null, 8, ["media"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})